import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/app/[locale]/error.tsx");
